import { useObjectTypeFeatureByAppSetting } from 'framework-app-settings-features-lib';
import { useObjectTypeId } from 'crm-object-board-core/objectTypeDefinition';
export const usePerPipelinePql = () => {
  const objectTypeId = useObjectTypeId();
  const {
    data: feature
  } = useObjectTypeFeatureByAppSetting(objectTypeId, 'crm_object_pipelines', 'cardCustomization');
  if (!feature) {
    return undefined;
  }
  return feature.perPipelinePqlKey;
};